import React from 'react'
import {
  ProjectsTableProps,
  projectsTableWidths
} from './ProjectsTable.types'
import styles from './ProjectsTable.module.scss'
// import cl from 'classnames'
import { TableContainer } from '../TableContainer'
import { TableHeader } from '../TableHeader'
import { TablePeriodFilter } from '../TablePeriodFilter'
import { TableBodyContainer } from '../TableBodyContainer'
import { ProjectsTableLine } from './ProjectsTableLine'
import { observer } from 'mobx-react-lite'
import {
  ProjectsTableSortProps,
  PROJECTS_TABLE_STORE
} from 'store'
import { inject } from 'mobx-react'
import { GenreTypes, ProjectTypes, StatusTypes } from 'models'
import { capitalize } from 'validate.js'
import tableBodyContainerStyles from '../TableBodyContainer/TableBodyContainer.module.scss'

const ProjectsTableComponent = (props: ProjectsTableProps) => {
  const {
    [PROJECTS_TABLE_STORE]: {
      searchResults,
      getSortDirection,
      handleSortDirectionChange,
      isColumnMarked,
      searchProps,
      onSearchPropsChange
    },
    isMyProfileRender,
    ...rest
  } = props

  const scrollbarSpacing = 4.8
  return (
    <TableContainer {...rest} className={styles.thinScroll}>
      <TableHeader
        tableColumns={[
          {
            label: 'Project name',
            // widthPercentage: projectsTableWidths.name,
            sortDirection: getSortDirection(ProjectsTableSortProps.NAME),
            setSortDirection: handleSortDirectionChange(ProjectsTableSortProps.NAME),
            isColumnMarked: isColumnMarked(ProjectsTableSortProps.NAME),
            inputProps: {
              placeholder: 'Search...',
              value: searchProps.name,
              onChange: name => onSearchPropsChange({ name })
            },
            widthPx: projectsTableWidths.name
          },
          {
            label: 'Type',
            // widthPercentage: projectsTableWidths.type,
            sortDirection: getSortDirection(ProjectsTableSortProps.TYPE),
            setSortDirection: handleSortDirectionChange(ProjectsTableSortProps.TYPE),
            isColumnMarked: isColumnMarked(ProjectsTableSortProps.TYPE),
            selectProps: {
              noneLabel: 'All',
              options: Object.values(ProjectTypes).map(type => ({
                label: type,
                value: type
              })),
              value: searchProps.type,
              onChange: (type: ProjectTypes) => onSearchPropsChange({ type })
            },
            widthPx: projectsTableWidths.type
          },
          {
            label: 'Added at',
            // widthPercentage: projectsTableWidths.addedAt,
            sortDirection: getSortDirection(ProjectsTableSortProps.ADDED_AT),
            setSortDirection: handleSortDirectionChange(ProjectsTableSortProps.ADDED_AT),
            isColumnMarked: isColumnMarked(ProjectsTableSortProps.ADDED_AT),
            filterComponent: (
              <TablePeriodFilter
                period={searchProps.addedAtStart
                  ? { start: searchProps.addedAtStart, end: searchProps.addedAtEnd }
                  : null
                }
                setPeriod={period => onSearchPropsChange({
                  addedAtStart: period ? period.start : null,
                  addedAtEnd: period ? period.end : null
                })}
              />
            ),
            widthPx: projectsTableWidths.addedAt
          },
          {
            label: 'Tags',
            // widthPercentage: projectsTableWidths.tags,
            inputProps: {
              placeholder: 'Search...',
              value: searchProps.tags,
              onChange: tags => onSearchPropsChange({ tags })
            },
            widthPx: projectsTableWidths.tags
          },
          {
            label: 'Input Token Used',
            sortDirection: getSortDirection(ProjectsTableSortProps.INPUT_TOKEN_USED),
            setSortDirection: handleSortDirectionChange(ProjectsTableSortProps.INPUT_TOKEN_USED),
            isColumnMarked: isColumnMarked(ProjectsTableSortProps.INPUT_TOKEN_USED),
            widthPx: projectsTableWidths.inputTokenUsed
          },
          {
            label: 'Output Token Used',
            sortDirection: getSortDirection(ProjectsTableSortProps.OUTPUT_TOKEN_USED),
            setSortDirection: handleSortDirectionChange(ProjectsTableSortProps.OUTPUT_TOKEN_USED),
            isColumnMarked: isColumnMarked(ProjectsTableSortProps.OUTPUT_TOKEN_USED),
            widthPx: projectsTableWidths.outputTokenUsed
          },
          {
            label: 'Genre',
            // widthPercentage: projectsTableWidths.genre,
            sortDirection: getSortDirection(ProjectsTableSortProps.GENRE),
            setSortDirection: handleSortDirectionChange(ProjectsTableSortProps.GENRE),
            isColumnMarked: isColumnMarked(ProjectsTableSortProps.GENRE),
            selectProps: {
              noneLabel: 'All',
              options: Object.values(GenreTypes).map(genre => ({
                label: genre,
                value: genre
              })),
              value: searchProps.genre,
              onChange: (genre: GenreTypes) => onSearchPropsChange({ genre })
            },
            widthPx: projectsTableWidths.genre
          },
          {
            label: 'Status',
            // widthPercentage: projectsTableWidths.status,
            selectProps: {
              noneLabel: 'All',
              options: Object.values(StatusTypes).map(status => ({
                label: capitalize(status.toLowerCase()),
                value: status
              })),
              value: searchProps.status,
              onChange: (status: StatusTypes) => onSearchPropsChange({ status })
            },
            widthPx: projectsTableWidths.status
          },
          {
            label: 'Published',
            // widthPercentage: projectsTableWidths.published,
            selectProps: {
              noneLabel: 'All',
              options: [
                { label: 'Yes', value: true },
                { label: 'No', value: false }
              ],
              value: searchProps.published,
              onChange: published => onSearchPropsChange({ published })
            },
            widthPx: isMyProfileRender ? 97 : projectsTableWidths.published
          },
          {
            label: 'Open in editor',
            // widthPercentage: projectsTableWidths.openInEditor
            widthPx: projectsTableWidths.openInEditor
          },
          {
            label: 'Delete project',
            // widthPercentage: projectsTableWidths.deleteProject
            widthPx: projectsTableWidths.deleteProject + scrollbarSpacing // For the avoid scroll bar spacing
          }
        ]}
      />
      <TableBodyContainer className={tableBodyContainerStyles.tableBodyContainer}>
        {searchResults.map(p => {
          return (
            <ProjectsTableLine
              key={p.id}
              project={p}
              isMyProfileRender={isMyProfileRender}
            />
          )
        })}
      </TableBodyContainer>
    </TableContainer>
  )
}

const ProjectsTable = inject(
  PROJECTS_TABLE_STORE
)(observer(ProjectsTableComponent))
export { ProjectsTable }
